class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    // 悬停切换同级菜单
    this.mainDetailsToggle.querySelector('summary').addEventListener('mouseenter', () => {
      const parent = this.parentElement;
      if (!parent) return;
      const siblings = [...parent.querySelectorAll(':scope > li > details-disclosure, :scope > details-disclosure')];
      const anyOpen = siblings.some(s => s.mainDetailsToggle && s.mainDetailsToggle.hasAttribute('open'));
      if (anyOpen) {
        siblings.forEach(s => {
          if (s !== this && s.mainDetailsToggle && s.mainDetailsToggle.hasAttribute('open')) {
            s.close();
          }
        });
        this.mainDetailsToggle.setAttribute('open', '');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
      }
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }

      connectedCallback() {
    requestAnimationFrame(() => {
      const li = this.closest('.header__submenu-item.has-children');
      const flyout = this.querySelector('.header__submenu--flyout');
      const portal = document.getElementById('flyout-portal');
      if (!li || !flyout || !portal) return;

      // 克隆 flyout 到 portal
      const clone = flyout.cloneNode(true);
      clone.style.cssText = `
        display: none;
        position: fixed;
        z-index: 99999;
        background: #ffffff;
        background-image: none;
        box-shadow: 0 4px 16px rgba(0,0,0,0.12);
        padding: 1rem 0;
        min-width: 18rem;
        pointer-events: auto;
      `;
      portal.appendChild(clone);

      // 隐藏原始 flyout
      flyout.style.display = 'none';

          let hideTimer = null;
          document.addEventListener('pointermove', (e) => {
  const overLi = li.contains(e.target) || li === e.target;
  const overClone = clone.contains(e.target) || clone === e.target;
  if (overLi || overClone) {
    clearTimeout(hideTimer);
    if (overClone) {
      const parentDetails = li.closest('details');
      if (parentDetails) parentDetails.setAttribute('open', '');
    }
  }
});


    li.addEventListener('mouseenter', () => {
      clearTimeout(hideTimer);
      const rect = li.getBoundingClientRect();
      clone.style.top = rect.top + 'px';
     clone.style.left = rect.right + 'px';
      clone.style.display = 'block';
      document.dispatchEvent(new CustomEvent('flyout-active'));
    });

    li.addEventListener('mouseleave', (e) => {
  const related = e.relatedTarget;
  hideTimer = setTimeout(() => {
    if (!clone.contains(related)) {
      clone.style.display = 'none';
    }
  }, 0);
});

    clone.addEventListener('mouseenter', () => {
  clearTimeout(hideTimer);
  const parentDetails = li.closest('details');
  if (parentDetails) parentDetails.setAttribute('open', '');
});

    clone.addEventListener('mouseleave', (e) => {
  const related = e.relatedTarget;
  hideTimer = setTimeout(() => {
    if (!li.contains(related)) {
      clone.style.display = 'none';
    }
  }, 150);
});HeaderMenu
    });
      }
  }

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.headerMenus = null;
    this._closeTimer = null;

    requestAnimationFrame(() => {
      this._bindPanelEvents();
    });

    // 悬停切换一级菜单
    this.mainDetailsToggle.querySelector('summary').addEventListener('mouseenter', () => {
      if (!this.headerMenus) {
        this.headerMenus = document.querySelectorAll('header-menu');
      }
      const anyOpen = [...this.headerMenus].some(menu => menu.mainDetailsToggle.hasAttribute('open'));
      if (anyOpen) {
        this.headerMenus.forEach(menu => {
          if (menu !== this) menu.closeAll();
        });
        this.mainDetailsToggle.setAttribute('open', '');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
      }
    });
  }

  _bindPanelEvents() {
    // 用 document 级别监听，捕获所有鼠标移动
    // 只要鼠标在 header-menu 范围内，始终保持面板开启
    this.addEventListener('pointerenter', () => {
      if (this._closeTimer) {
        clearTimeout(this._closeTimer);
        this._closeTimer = null;
      }
    });

    this.addEventListener('pointerleave', (e) => {
  if (e.relatedTarget && this.contains(e.relatedTarget)) return;
  const portal = document.getElementById('flyout-portal');
  if (portal && portal.contains(e.relatedTarget)) return;
  this._closeTimer = setTimeout(() => {
    const el = document.elementFromPoint(
      window._lastPointerX || 0,
      window._lastPointerY || 0
    );
    if (portal && el && portal.contains(el)) return;
    this.closeAll();
    this._closeTimer = null;
  }, 300);
});
  }

  closeAll() {
    this.querySelectorAll('details-disclosure').forEach(d => d.close());
    this.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
